import { render } from "./product-card.vue?vue&type=template&id=41265067"
import script from "./product-card.vue?vue&type=script&lang=js"
export * from "./product-card.vue?vue&type=script&lang=js"

import "./product-card.vue?vue&type=style&index=0&id=41265067&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__